import { Component } from '@angular/core'

@Component({
  selector: 'app-template',
  templateUrl: './template-page.component.html',
  styleUrls: [`./template-page.component.scss`],
})
export class TemplatePageComponent {}
